import {
    Component,
    Inject,
    Input,
    OnChanges,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import {
    AUTH_SERVICE_IMPL,
    DeliveringTaskListItem,
    DeliveryTaskState,
    IAuthenticationService,
    ModalService,
    UserRole,
} from 'shared';
import { PaymentType } from 'shared';
import { MyTasksService } from 'dm-src/app/modules/my-tasks/my-tasks.service';
import { DeliveringTaskButtonsComponent } from 'dm-src/app/modules/my-tasks/task-group/task-group-item/delivering-task-item/delivering-task-buttons/delivering-task-buttons.component';

@Component({
    selector: '[dynamic-delivering-task-item]',
    templateUrl: './dynamic-delivering-task-item.component.html',
    styleUrls: ['./dynamic-delivering-task-item.component.scss'],
})
export class DynamicDeliveringTaskItemComponent implements OnChanges {
    @Input() public task: DeliveringTaskListItem;
    @Input() public badgeText: string;
    @Input() public groupCollapsed = false;
    @ViewChild(DeliveringTaskButtonsComponent)
    private _buttons: DeliveringTaskButtonsComponent;

    public isCollapsed = true;
    public PaymentType = PaymentType;
    private readonly _canEditDelivererNotes: boolean;

    constructor(
        private readonly _myTasksService: MyTasksService,
        private readonly _modalService: ModalService,
        @Inject(AUTH_SERVICE_IMPL) private readonly _authService: IAuthenticationService
    ) {
        this._canEditDelivererNotes = this._authService.currentUser.hasRoles([
            UserRole.Administrator,
            UserRole.Deliverer,
        ]);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.groupCollapsed?.currentValue) {
            this.isCollapsed = true;
            this._buttons?.handleCollapse(true);
        }
    }

    public get isDone(): boolean {
        return this.task.state === DeliveryTaskState[DeliveryTaskState.Done];
    }

    public get isDelivererNotesVisible(): boolean {
        return (
            this._canEditDelivererNotes &&
            (this.task.state === DeliveryTaskState[DeliveryTaskState.ToDo] ||
                this.task.state === DeliveryTaskState[DeliveryTaskState.InProgress])
        );
    }

    public toggleCard(): void {
        if (this.isDone) {
            return;
        }

        this.isCollapsed = !this.isCollapsed;
        this._buttons?.handleCollapse(this.isCollapsed);
    }

    public showCheckModal(event: Event): void {
        event.stopPropagation();
        this._myTasksService.setSelectedTask(this.task);
        this._modalService.setModalVisibility(true, 'package-verify-modal');
    }
}
